<svg style="display:none" aria-hidden="true">
  <symbol id="i-sparkle" viewBox="0 0 24 24"><path d="M12 3l1.8 4.6L18 9l-4.2 1.4L12 15l-1.8-4.6L6 9l4.2-1.4L12 3z"/><path d="M19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9L19 15z"/></symbol>
  <symbol id="i-calendar" viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="16" rx="2"/><path d="M3.5 9.5h17"/><path d="M8 3v4M16 3v4"/><path d="M8.5 13.5l1.7 1.7 3.3-3.4"/></symbol>
  <symbol id="i-grid" viewBox="0 0 24 24"><rect x="4" y="4" width="6.5" height="6.5" rx="1"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1"/></symbol>
  <symbol id="i-check" viewBox="0 0 24 24"><path d="M4.5 12.5l5 5 10-11"/></symbol>
  <symbol id="i-report" viewBox="0 0 24 24"><path d="M4 20V10M11 20V4M18 20v-7"/><path d="M4 20h14.5"/></symbol>
  <symbol id="i-heart" viewBox="0 0 24 24"><path d="M12 20s-7.5-4.6-9.5-9.4C1.2 7.1 3 4 6.4 4c2 0 3.4 1 5.6 3.4C14.2 5 15.6 4 17.6 4 21 4 22.8 7.1 21.5 10.6 19.5 15.4 12 20 12 20z"/></symbol>
  <symbol id="i-chat" viewBox="0 0 24 24"><path d="M4 5.5h16v10.5H9.5L5 20v-4H4z"/><path d="M8 9.5h8M8 12.5h5"/></symbol>
  <symbol id="i-phone" viewBox="0 0 24 24"><path d="M6 3.5c1 0 2.7 2.3 2.7 3.3S7 8.7 7 9.6c0 1.7 3 6.4 5.4 7.8 1 .6 2.4-1.6 3.4-1.6.9 0 3.3 1.7 3.3 2.7 0 1.6-1.5 2.5-3 2.5-5.6 0-12-6.4-12-12 0-1.5.9-3 2.9-4.5z"/></symbol>
  <symbol id="i-mail" viewBox="0 0 24 24"><rect x="3.5" y="5.5" width="17" height="13" rx="2"/><path d="M4.5 6.5l7.5 6.5 7.5-6.5"/></symbol>
  <symbol id="i-award" viewBox="0 0 24 24"><circle cx="12" cy="9" r="5.5"/><path d="M9 13.5L7 21l5-2.5 5 2.5-2-7.5"/></symbol>
  <symbol id="i-clock" viewBox="0 0 24 24"><circle cx="12" cy="12.5" r="8"/><path d="M12 8v4.5l3 2"/><path d="M9 3h6"/></symbol>
  <symbol id="i-monitor" viewBox="0 0 24 24"><rect x="3.5" y="4.5" width="17" height="12" rx="2"/><path d="M8 20.5h8M12 16.5v4"/></symbol>
  <symbol id="i-sliders" viewBox="0 0 24 24"><path d="M5 6h14M5 12h14M5 18h14"/><circle cx="9" cy="6" r="1.8"/><circle cx="16" cy="12" r="1.8"/><circle cx="10" cy="18" r="1.8"/></symbol>
  <symbol id="i-trophy" viewBox="0 0 24 24"><path d="M8 4h8v5a4 4 0 01-8 0V4z"/><path d="M8 5.5H5.5A2.5 2.5 0 008 9M16 5.5h2.5A2.5 2.5 0 0116 9"/><path d="M10.5 13v3M13.5 13v3"/><path d="M8.5 20.5h7M8.5 20.5c0-1.6.7-2.5 1.7-3h3.6c1 .5 1.7 1.4 1.7 3"/></symbol>
  <symbol id="i-laptop" viewBox="0 0 24 24"><rect x="5" y="4.5" width="14" height="9.5" rx="1.4"/><path d="M2.5 18.5h19l-1.6-3H4.1z"/></symbol>
  <symbol id="i-clipboard" viewBox="0 0 24 24"><rect x="5.5" y="4.5" width="13" height="16" rx="2"/><rect x="9" y="3" width="6" height="3" rx="1"/><path d="M8.5 12l2 2 4-4.5"/></symbol>
  <symbol id="i-bolt" viewBox="0 0 24 24"><path d="M13 3L6 13.5h5L10.5 21 18 9.5h-5z"/></symbol>
  <symbol id="i-sun" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4.5"/><path d="M12 2.5v2.5M12 19v2.5M4.4 4.4l1.8 1.8M17.8 17.8l1.8 1.8M2.5 12H5M19 12h2.5M4.4 19.6l1.8-1.8M17.8 6.2l1.8-1.8"/></symbol>
  <symbol id="i-book" viewBox="0 0 24 24"><path d="M4 5.2C6 4 8.6 4 11 5v14c-2.4-1-5-1-7 .2z"/><path d="M20 5.2C18 4 15.4 4 13 5v14c2.4-1 5-1 7 .2z"/></symbol>
</svg>

<div class="ps-wrap">

  <!-- ============ HERO ============ -->
  <section class="ps-hero">
    <div class="ps-container ps-hero-grid">

      <div class="ps-hero-copy">
        <span class="ps-kicker"><svg class="ps-icon"><use href="#i-sparkle"/></svg>Tutoring &amp; Mock Exams · UK &amp; UAE</span>
        <h1>Exam prep that adapts&nbsp;to your child - not the other way around</h1>
        <p class="ps-lead">From KS2 to A-Level, our tutors and mock exam centres cover every major board, so students walk into the real thing having already sat something just like it.</p>

        <div class="ps-hero-cta">
          <a href="https://go.sehyog.co.uk/FreeDemoForm" class="ps-btn ps-btn-primary"><svg class="ps-icon"><use href="#i-calendar"/></svg>Book a free demo</a>
        </div>

        <div class="ps-hero-stats">
          <div class="ps-stat"><h3>10,000+</h3><span>Students taught</span></div>
          <div class="ps-stat"><h3>15+</h3><span>Subjects covered</span></div>
          <div class="ps-stat"><h3>10+</h3><span>Exam boards</span></div>
        </div>
      </div>

      <div class="ps-hero-visual">
        <div class="ps-visual-frame">
          <div class="ps-visual-topbar">
            <div class="ps-visual-dots"><span></span><span></span><span></span></div>
            <h4>Result Analysis Report</h4>
          </div>
          <div class="ps-visual-ring">
            <div class="ps-visual-ring-inner"><strong>78%</strong><span>Accuracy</span></div>
          </div>
          <p class="ps-visual-caption">Verbal Reasoning · Mock 3</p>
          <div class="ps-visual-boards">
            <span>ISEB</span><span>GL</span><span>CSSE</span><span>AQA</span><span>OCR</span>
          </div>
        </div>

        <div class="ps-visual-callout">
          <svg class="ps-icon"><use href="#i-clock"/></svg>
          <div><strong>Feedback in 48 hrs</strong><span>Marked &amp; annotated</span></div>
        </div>
      </div>

    </div>
  </section>

  <div class="ps-trust">
    <div class="ps-container ps-trust-row">
      <span class="ps-trust-label">Boards we teach to</span>
      <span class="ps-trust-chip">GL</span>
      <span class="ps-trust-chip">CSSE</span>
      <span class="ps-trust-chip">FSCE</span>
      <span class="ps-trust-chip">SET</span>
      <span class="ps-trust-chip">ISEB</span>
      <span class="ps-trust-chip">AQA</span>
      <span class="ps-trust-chip">OCR</span>
      <span class="ps-trust-chip">Edexcel</span>
      <span class="ps-trust-chip">Eduqas</span>
    </div>
  </div>

  <!-- ============ OFFERINGS ============ -->
  <section class="ps-section" id="ps-offerings">
    <div class="ps-container">

      <div class="ps-section-head">
        <span class="ps-kicker"><svg class="ps-icon"><use href="#i-grid"/></svg>What we offer</span>
        <h2>Four ways we prepare students</h2>
        <p>Every programme is built around the same idea: practise like the real exam, then fix exactly what's holding a student back.</p>
      </div>

      <!-- Offer 1: Online tutoring -->
      <div class="ps-offer">
        <div class="ps-offer-media">
          <span class="ps-offer-num">01 / Tutoring</span>
          <svg viewBox="0 0 160 160" fill="none">
            <circle cx="118" cy="42" r="16" fill="#01BAEF" opacity="0.85"/>
            <circle cx="128" cy="100" r="9" fill="#F5A623"/>
            <circle cx="30" cy="110" r="7" fill="#F5A623" opacity="0.8"/>
            <rect x="30" y="46" width="100" height="66" rx="8" fill="#0E3A50"/>
            <rect x="38" y="54" width="84" height="50" rx="4" fill="#0B4F6C"/>
            <rect x="46" y="62" width="40" height="5" rx="2.5" fill="#01BAEF"/>
            <rect x="46" y="73" width="60" height="5" rx="2.5" fill="#ffffff" opacity="0.55"/>
            <rect x="46" y="84" width="50" height="5" rx="2.5" fill="#ffffff" opacity="0.35"/>
            <path d="M14 118L146 118L134 132L26 132Z" fill="#0E3A50"/>
            <path d="M104 40l2.6 6.4L113 49l-6.4 2.6L104 58l-2.6-6.4L95 49l6.4-2.6L104 40z" fill="#F5A623"/>
          </svg>
        </div>
        <div class="ps-offer-body">
          <h3>Online tutoring</h3>
          <p>Personalised, interactive sessions for Year 3 to Year 13, built by tutors who plan around what a student actually struggles with - not a fixed syllabus.</p>
          <ul class="ps-offer-list">
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Maths, English, Reasoning &amp; Science</li>
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Computer Science, Languages, Humanities</li>
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Small groups or 1-to-1</li>
          </ul>
          <a href="https://go.sehyog.co.uk/FreeDemoForm" class="ps-btn ps-btn-primary">Book a free demo</a>
        </div>

        <div class="ps-offer-tiers">
          <div class="ps-tier">
            <h5>KS2 / 11+</h5>
            <span class="ps-tier-boards">GL · CSSE · FSCE · SET · ISEB</span>
            <ul>
              <li>Mathematics</li>
              <li>English &amp; creative writing</li>
              <li>Verbal, non-verbal &amp; spatial reasoning</li>
            </ul>
          </div>
          <div class="ps-tier">
            <h5>KS3 &amp; GCSE</h5>
            <span class="ps-tier-boards">AQA · OCR · Edexcel · Eduqas</span>
            <ul>
              <li>Mathematics &amp; combined science</li>
              <li>English literature &amp; language</li>
              <li>Computer science, French, German, Spanish</li>
            </ul>
          </div>
          <div class="ps-tier">
            <h5>AS &amp; A-Level</h5>
            <span class="ps-tier-boards">AQA · OCR · Edexcel · Eduqas</span>
            <ul>
              <li>Mathematics &amp; further maths</li>
              <li>Biology, chemistry, physics</li>
              <li>English, computer science &amp; languages</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Offer 2: Mocks -->
      <div class="ps-offer">
        <div class="ps-offer-media">
          <span class="ps-offer-num">02 / Mocks</span>
          <svg viewBox="0 0 160 160" fill="none">
            <rect x="42" y="26" width="70" height="94" rx="6" fill="#ffffff"/>
            <rect x="52" y="40" width="50" height="4.5" rx="2.25" fill="#0B4F6C" opacity="0.7"/>
            <rect x="52" y="51" width="50" height="4.5" rx="2.25" fill="#0B4F6C" opacity="0.4"/>
            <rect x="52" y="62" width="34" height="4.5" rx="2.25" fill="#0B4F6C" opacity="0.4"/>
            <rect x="52" y="76" width="50" height="4.5" rx="2.25" fill="#0B4F6C" opacity="0.4"/>
            <rect x="52" y="87" width="34" height="4.5" rx="2.25" fill="#0B4F6C" opacity="0.4"/>
            <rect x="52" y="101" width="42" height="4.5" rx="2.25" fill="#0B4F6C" opacity="0.4"/>
            <circle cx="118" cy="112" r="24" fill="#F5A623"/>
            <path d="M107 112l7 7 13-15" stroke="#06253A" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <circle cx="34" cy="40" r="14" fill="#01BAEF" opacity="0.9"/>
            <path d="M34 33v7l5 3" stroke="#06253A" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
        </div>
        <div class="ps-offer-body">
          <h3>Mocks &amp; assessments</h3>
          <p>Real exam conditions, real timing, real paper formats - so the actual test day feels familiar instead of frightening.</p>
          <ul class="ps-offer-list">
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Exposure to genuine exam-style questions</li>
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Timed conditions to build stamina and pace</li>
            <li><svg class="ps-icon"><use href="#i-check"/></svg>A written report showing exactly where marks were lost</li>
          </ul>
          <a [routerLink]="['/freedemo']" class="ps-btn ps-btn-primary">Book a mock test</a>
        </div>

        <div class="ps-offer-tiers">
          <div class="ps-tier">
            <h5>11+ mock tests</h5>
            <span class="ps-tier-boards">CSSE · FSCE · GL · SET · ISEB</span>
            <ul>
              <li>Face-to-face &amp; online</li>
              <li>Ilford, Chelmsford, Southend-on-Sea</li>
              <li>Basildon, Bexleyheath, Amersham + more</li>
            </ul>
            <a [routerLink]="['/11plus-mocktest']" class="ps-tier-link">Book 11+ mock test</a>
          </div>
          <div class="ps-tier">
            <h5>GCSE mock tests</h5>
            <span class="ps-tier-boards">AQA · OCR · Edexcel · Eduqas</span>
            <ul>
              <li>Face-to-face &amp; online</li>
              <li>Slough, Sutton, Harrow</li>
              <li>Full papers, marked &amp; annotated</li>
            </ul>
            <a [routerLink]="['/gcse-mocktest']" class="ps-tier-link">Book GCSE mock test</a>
          </div>
          <div class="ps-tier">
            <h5>What you get</h5>
            <span class="ps-tier-boards">Every sitting</span>
            <ul>
              <li>Marked script returned</li>
              <li>Result Analysis Report</li>
              <li>Recommended next steps</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Offer 3: Crash courses -->
      <div class="ps-offer">
        <div class="ps-offer-media">
          <span class="ps-offer-num">03 / Crash courses</span>
          <svg viewBox="0 0 160 160" fill="none">
            <g transform="rotate(-8 60 100)"><rect x="26" y="94" width="66" height="14" rx="2.5" fill="#0E3A50"/></g>
            <g transform="rotate(4 60 82)"><rect x="30" y="76" width="66" height="14" rx="2.5" fill="#0B4F6C"/></g>
            <g transform="rotate(-3 60 64)"><rect x="28" y="58" width="66" height="14" rx="2.5" fill="#01BAEF" opacity="0.9"/></g>
            <path d="M104 30L76 78h20L86 128l46-58H112z" fill="#F5A623"/>
            <path d="M104 30L76 78h20L86 128l46-58H112z" stroke="#06253A" stroke-width="2" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="ps-offer-body">
          <h3>Crash courses</h3>
          <p>Short, high-intensity sessions for students with a specific exam coming up fast - built to cover ground quickly without cutting corners.</p>
          <ul class="ps-offer-list">
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Full syllabus coverage in a compressed timeline</li>
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Strategies for answering under pressure</li>
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Second-round and late-entry exam prep</li>
          </ul>
          <a [routerLink]="['/freedemo']" class="ps-btn ps-btn-primary">View crash courses</a>
        </div>

        <div class="ps-offer-tiers">
          <div class="ps-tier">
            <h5>11+</h5>
            <span class="ps-tier-boards">CSSE · FSCE · GL · SET · ISEB</span>
            <ul>
              <li>April – July crash course</li>
              <li>Creative writing intensive</li>
              <li>HBS &amp; Sutton second-round prep</li>
            </ul>
            <a href="https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course" class="ps-tier-link">View 11+ crash courses</a>
          </div>
          <div class="ps-tier">
            <h5>GCSE &amp; A-Level</h5>
            <span class="ps-tier-boards">AQA · OCR · Edexcel · Eduqas</span>
            <ul>
              <li>September – April comprehensive course</li>
              <li>March – April revision course</li>
              <li>Late-entry exam preparation</li>
            </ul>
            <a href="https://www.sehyog.co.uk/11plus-help-club/category/gcse-rapid-course" class="ps-tier-link">View GCSE crash courses</a>
          </div>
          <div class="ps-tier">
            <h5>Also covers</h5>
            <span class="ps-tier-boards">SATs &amp; transitions</span>
            <ul>
              <li>12+ and 13+ entry</li>
              <li>SATs preparation</li>
              <li>Result Analysis Report included</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Offer 4: Holiday intensives -->
      <div class="ps-offer">
        <div class="ps-offer-media">
          <span class="ps-offer-num">04 / Holiday intensives</span>
          <svg viewBox="0 0 160 160" fill="none">
            <circle cx="80" cy="60" r="30" fill="#F5A623"/>
            <g stroke="#F5A623" stroke-width="5" stroke-linecap="round">
              <path d="M80 12v14"/><path d="M80 94v14"/>
              <path d="M32 60H18"/><path d="M142 60h-14"/>
              <path d="M45.7 25.7l-9.9-9.9"/><path d="M124.2 94.2l9.9 9.9"/>
              <path d="M45.7 94.2l-9.9 9.9"/><path d="M124.2 25.7l9.9-9.9"/>
            </g>
            <rect x="34" y="108" width="92" height="34" rx="6" fill="#ffffff"/>
            <rect x="34" y="108" width="92" height="12" rx="6" fill="#0B4F6C"/>
            <circle cx="47" cy="128" r="3.5" fill="#01BAEF"/>
            <path d="M58 128l3 3 5-6" stroke="#0B4F6C" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <rect x="74" y="125" width="34" height="5" rx="2.5" fill="#0B4F6C" opacity="0.35"/>
          </svg>
        </div>
        <div class="ps-offer-body">
          <h3>Summer &amp; holiday intensives</h3>
          <p>Holidays without a routine can undo a term of progress. These programmes keep momentum going and get students ready for what's next.</p>
          <ul class="ps-offer-list">
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Past papers &amp; full mock exams</li>
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Reinforcing foundational concepts</li>
            <li><svg class="ps-icon"><use href="#i-check"/></svg>Preparing for the next academic year</li>
          </ul>
          <a href="https://go.sehyog.co.uk/FreeDemoForm" class="ps-btn ps-btn-primary">Book a free demo</a>
        </div>
      </div>

    </div>
  </section>

  <!-- ============ RAR ============ -->
  <section class="ps-rar">
    <div class="ps-container ps-rar-grid">

      <div class="ps-rar-copy">
        <span class="ps-kicker"><svg class="ps-icon"><use href="#i-report"/></svg>How we track progress</span>
        <h2>Result Analysis Report (RAR)</h2>
        <p>A single, clear picture of how your child performed - question by question - so tutoring time goes where it actually matters.</p>

        <div class="ps-steps">
          <div class="ps-step">
            <span class="ps-step-num">1</span>
            <div><h5>Sit the mock</h5><p>Under real, timed exam conditions.</p></div>
          </div>
          <div class="ps-step">
            <span class="ps-step-num">2</span>
            <div><h5>We mark &amp; break it down</h5><p>By topic, question type and paper section.</p></div>
          </div>
          <div class="ps-step">
            <span class="ps-step-num">3</span>
            <div><h5>You get the RAR</h5><p>Strengths, gaps, and what to work on next.</p></div>
          </div>
        </div>

        <a href="https://go.sehyog.co.uk/FreeDemoForm" class="ps-btn ps-btn-on-dark"><svg class="ps-icon"><use href="#i-calendar"/></svg>Book a free demo</a>
      </div>

      <div class="ps-rar-visual">
        <div class="ps-rar-visual-row"><h4>Score by topic</h4><svg class="ps-icon"><use href="#i-report"/></svg></div>
        <div class="ps-rar-bars">
          <div class="ps-rar-bar" style="height:55%;"><span>52%</span></div>
          <div class="ps-rar-bar" style="height:88%;"><span>84%</span></div>
          <div class="ps-rar-bar" style="height:70%;"><span>66%</span></div>
          <div class="ps-rar-bar" style="height:40%;"><span>38%</span></div>
          <div class="ps-rar-bar" style="height:76%;"><span>72%</span></div>
        </div>
        <div class="ps-rar-legend">
          <span>Comprehension</span><span>Maths</span><span>Verbal</span><span>Non-verbal</span><span>Writing</span>
        </div>
      </div>

    </div>
  </section>

  <!-- ============ WHY CHOOSE US ============ -->
  <section class="ps-section">
    <div class="ps-container">
      <div class="ps-section-head">
        <span class="ps-kicker"><svg class="ps-icon"><use href="#i-heart"/></svg>Why families stay</span>
        <h2>Why choose Sehyog Academy?</h2>
      </div>

      <div class="ps-why-grid">
        <div class="ps-why-card">
          <div class="ps-why-icon"><svg class="ps-icon"><use href="#i-award"/></svg></div>
          <h3>Qualified tutors</h3>
          <p>Experienced, subject-qualified educators who are genuinely invested in each student's progress.</p>
        </div>
        <div class="ps-why-card">
          <div class="ps-why-icon"><svg class="ps-icon"><use href="#i-clock"/></svg></div>
          <h3>Flexible learning</h3>
          <p>Scheduling that works around school, activities and family life - not the other way round.</p>
        </div>
        <div class="ps-why-card">
          <div class="ps-why-icon"><svg class="ps-icon"><use href="#i-monitor"/></svg></div>
          <h3>Interactive technology</h3>
          <p>A modern online platform built for engagement, not just a video call with a whiteboard.</p>
        </div>

        <div class="ps-why-row2">
          <div class="ps-why-card">
            <div class="ps-why-icon"><svg class="ps-icon"><use href="#i-sliders"/></svg></div>
            <h3>Customised plans</h3>
            <p>Every learning plan is built around one student's specific goals - never a one-size-fits-all syllabus.</p>
          </div>
          <div class="ps-why-card">
            <div class="ps-why-icon"><svg class="ps-icon"><use href="#i-trophy"/></svg></div>
            <h3>Proven results</h3>
            <p>A consistent track record of students succeeding in competitive exams and school assessments.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ TESTIMONIALS ============ -->
  <section class="ps-section ps-testi">
    <div class="ps-container">
      <div class="ps-section-head" style="margin: 0 auto 48px; text-align:center;">
        <span class="ps-kicker"><svg class="ps-icon"><use href="#i-chat"/></svg>Parent feedback</span>
        <h2>What parents tell us</h2>
      </div>

      <div class="ps-testi-track">
        <div class="ps-testi-card">
          <div class="ps-testi-stars">★★★★★</div>
          <p class="ps-testi-quote">The mock exams took the mystery out of the real thing. My son knew exactly what to expect.</p>
          <div class="ps-testi-person">
            <div class="ps-testi-avatar">R</div>
            <div><strong>Ravi K.</strong><span>Parent, Year 6</span></div>
          </div>
        </div>

        <div class="ps-testi-card ps-testi-main">
          <div class="ps-testi-stars">★★★★★</div>
          <p class="ps-testi-quote">The Result Analysis Report was the turning point - for the first time we could see exactly which topics needed work, instead of guessing.</p>
          <div class="ps-testi-person">
            <div class="ps-testi-avatar">A</div>
            <div><strong>Amina S.</strong><span>Parent, GCSE student</span></div>
          </div>
        </div>

        <div class="ps-testi-card">
          <div class="ps-testi-stars">★★★★★</div>
          <p class="ps-testi-quote">Flexible scheduling meant we never had to choose between tutoring and football practice.</p>
          <div class="ps-testi-person">
            <div class="ps-testi-avatar">D</div>
            <div><strong>David P.</strong><span>Parent, Year 9</span></div>
          </div>
        </div>
      </div>
      <p class="ps-testi-note">Placeholder quotes - swap in real testimonials when ready.</p>
    </div>
  </section>

  <!-- ============ CTA + CONTACT ============ -->
  <section class="ps-section" style="padding-top: 0;">
    <div class="ps-container">
      <div class="ps-cta-band">
        <div>
          <h2>See where your child stands, before it counts</h2>
          <p>Book a free demo lesson or a mock exam slot - no commitment, just a clear next step.</p>
          <a href="https://go.sehyog.co.uk/FreeDemoForm" class="ps-btn ps-btn-on-dark"><svg class="ps-icon"><use href="#i-calendar"/></svg>Book a free demo</a>
        </div>
        <div class="ps-contact-list">
          <a href="tel:03301339827" class="ps-contact-item"><svg class="ps-icon"><use href="#i-phone"/></svg><div><strong>Hotline</strong><span>0330 133 9827</span></div></a>
          <div class="ps-contact-item" (click)="openWhatsApp()"><svg class="ps-icon"><use href="#i-chat"/></svg><div><strong>WhatsApp</strong><span>+44 7464 772331</span></div></div>
          <a href="mailto:support@sehyog.co.uk" class="ps-contact-item"><svg class="ps-icon"><use href="#i-mail"/></svg><div><strong>Email</strong><span>support&#64;sehyog.co.uk</span></div></a>
        </div>
      </div>
    </div>
  </section>

</div>